/**
 * @generated SignedSource<<0ec4ebb366ddb4b2e9dda19af7204012>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type Currency = "CAD" | "EUR" | "GBP" | "USD";
export type PaymentStatus = "APPROVED" | "CANCELED" | "COMPLETED" | "FAILED" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type buildBookingConfirmationAnalyticsData_booking$data = {
  readonly id: string;
  readonly orders: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly orderPayments: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly status: PaymentStatus | null | undefined;
              readonly transactionId: string | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly total: number | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly startSlot: {
    readonly agenda: {
      readonly facility: {
        readonly department: {
          readonly club: {
            readonly currency: Currency;
          } | null | undefined;
        } | null | undefined;
      };
    };
  } | null | undefined;
  readonly " $fragmentType": "buildBookingConfirmationAnalyticsData_booking";
};
export type buildBookingConfirmationAnalyticsData_booking$key = {
  readonly " $data"?: buildBookingConfirmationAnalyticsData_booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"buildBookingConfirmationAnalyticsData_booking">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "buildBookingConfirmationAnalyticsData_booking"
};

(node as any).hash = "49fa949f431e89298efc5bddb9e07ee5";

export default node;
